module.exports = __webpack_public_path__ + "img/phone_connected_md.2c58d16c.png";